import { createFileRoute } from '@tanstack/react-router';
import { SignInPage } from '../sign-in/SignInPage.js';

export const Route = createFileRoute('/')({ component: SignInPage });
